import { int32ToString } from "../fable_modules/fable-library.4.1.4/Util.js";
import { Union } from "../fable_modules/fable-library.4.1.4/Types.js";
import { union_type, option_type, int32_type } from "../fable_modules/fable-library.4.1.4/Reflection.js";
import { initialize, sum as sum_2 } from "../fable_modules/fable-library.4.1.4/List.js";
import { rand, thunk1 } from "../Core/Common.fs.js";
import { op_UnaryNegation_Int32 } from "../fable_modules/fable-library.4.1.4/Int32.js";
import { $007CInt$007C_$007C, pack, $007CIntNoWhitespace$007C_$007C, $007CStr$007C_$007C } from "../Core/Packrat.fs.js";

export class RollSpec extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["StaticBonus", "RollSpec"];
    }
    toString() {
        const this$ = this;
        const loop = (needsOperator, _arg) => {
            if (_arg.tag === 1) {
                const rest = _arg.fields[2];
                const n_1 = _arg.fields[0] | 0;
                const d = _arg.fields[1] | 0;
                const d_1 = (d === 6) ? "" : int32ToString(d);
                const prefix = (needsOperator && (n_1 >= 0)) ? (`+${n_1}d${d_1}`) : (`${n_1}d${d_1}`);
                let matchResult, rest_1;
                if (rest != null) {
                    if (rest.tag === 0) {
                        if (rest.fields[0] === 0) {
                            matchResult = 0;
                        }
                        else {
                            matchResult = 1;
                            rest_1 = rest;
                        }
                    }
                    else {
                        matchResult = 1;
                        rest_1 = rest;
                    }
                }
                else {
                    matchResult = 0;
                }
                switch (matchResult) {
                    case 0:
                        return prefix;
                    default:
                        return `${prefix}${loop(true, rest_1)}`;
                }
            }
            else {
                const n = _arg.fields[0] | 0;
                if (needsOperator && (n >= 0)) {
                    return `+${n}`;
                }
                else {
                    return int32ToString(n);
                }
            }
        };
        return loop(false, this$);
    }
}

export function RollSpec_$reflection() {
    return union_type("Domain.Random.RollSpec", [], RollSpec, () => [[["Item", int32_type]], [["n", int32_type], ["d", int32_type], ["rest", option_type(RollSpec_$reflection())]]]);
}

export function RollSpec__roll(this$) {
    const loop = (_arg) => {
        if (_arg.tag === 1) {
            const rest = _arg.fields[2];
            const n_1 = _arg.fields[0] | 0;
            const sum = sum_2(initialize(Math.abs(n_1), (arg20$0040) => thunk1(rand, _arg.fields[1], arg20$0040)), {
                GetZero: () => 0,
                Add: (x_1, y) => (x_1 + y),
            }) | 0;
            const sum_1 = ((n_1 < 0) ? op_UnaryNegation_Int32(sum) : sum) | 0;
            if (rest == null) {
                return sum_1 | 0;
            }
            else {
                return (sum_1 + loop(rest)) | 0;
            }
        }
        else {
            return _arg.fields[0] | 0;
        }
    };
    return loop(this$) | 0;
}

export function RollSpec_create_Z524259A4(bonus) {
    return new RollSpec(0, [bonus]);
}

export function RollSpec_create_Z37302880(n, d) {
    return new RollSpec(1, [n, d, void 0]);
}

export function RollSpec_create_4F7761DC(n, d, bonus) {
    if (bonus !== 0) {
        return new RollSpec(1, [n, d, new RollSpec(0, [bonus])]);
    }
    else {
        return new RollSpec(1, [n, d, void 0]);
    }
}

export function RollSpec_create_4399B0C6(n, d, rest) {
    return new RollSpec(1, [n, d, rest]);
}

export function RollSpec_op_Addition_667FC65A(lhs, rhs) {
    const addBonus = (bonus, _arg) => {
        if (_arg.tag === 1) {
            if (_arg.fields[2] != null) {
                const rest = _arg.fields[2];
                return new RollSpec(1, [_arg.fields[0], _arg.fields[1], addBonus(bonus, rest)]);
            }
            else {
                return new RollSpec(1, [_arg.fields[0], _arg.fields[1], new RollSpec(0, [bonus])]);
            }
        }
        else {
            return new RollSpec(0, [_arg.fields[0] + bonus]);
        }
    };
    return addBonus(rhs, lhs);
}

export function RollSpec_op_Addition_6A911740(lhs, rhs) {
    const addRhs = (_arg) => {
        if (_arg.tag === 1) {
            if (_arg.fields[2] != null) {
                const rest = _arg.fields[2];
                return new RollSpec(1, [_arg.fields[0], _arg.fields[1], addRhs(rest)]);
            }
            else {
                return new RollSpec(1, [_arg.fields[0], _arg.fields[1], rhs]);
            }
        }
        else {
            return RollSpec_op_Addition_667FC65A(rhs, _arg.fields[0]);
        }
    };
    return addRhs(lhs);
}

export function RollSpec_op_Subtraction_Z37302880(lhs, rhs) {
    return lhs + op_UnaryNegation_Int32(rhs);
}

export function RollSpec_op_Subtraction_6A911740(lhs, rhs) {
    const invert = (_arg) => {
        if (_arg.tag === 1) {
            if (_arg.fields[2] != null) {
                const rest = _arg.fields[2];
                return new RollSpec(1, [op_UnaryNegation_Int32(_arg.fields[0]), _arg.fields[1], invert(rest)]);
            }
            else {
                return new RollSpec(1, [op_UnaryNegation_Int32(_arg.fields[0]), _arg.fields[1], void 0]);
            }
        }
        else {
            return new RollSpec(0, [op_UnaryNegation_Int32(_arg.fields[0])]);
        }
    };
    return RollSpec_op_Addition_6A911740(lhs, invert(rhs));
}

export function Parser_$007CDieSize$007C_$007C(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    let matchResult, n, rest;
    const activePatternResult = $007CStr$007C_$007C("d", _arg[0], _arg[1]);
    if (activePatternResult != null) {
        const activePatternResult_1 = $007CIntNoWhitespace$007C_$007C(activePatternResult);
        if (activePatternResult_1 != null) {
            matchResult = 0;
            n = activePatternResult_1[0];
            rest = activePatternResult_1[1];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return [n, rest];
        default: {
            const activePatternResult_2 = $007CStr$007C_$007C("d", _arg[0], _arg[1]);
            if (activePatternResult_2 != null) {
                const rest_1 = activePatternResult_2;
                return [6, rest_1];
            }
            else {
                return void 0;
            }
        }
    }
}

export function Parser_$007CIntModifier$007C_$007C(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    let matchResult, bonus, rest;
    const activePatternResult = $007CStr$007C_$007C("+", _arg[0], _arg[1]);
    if (activePatternResult != null) {
        const activePatternResult_1 = $007CIntNoWhitespace$007C_$007C(activePatternResult);
        if (activePatternResult_1 != null) {
            matchResult = 0;
            bonus = activePatternResult_1[0];
            rest = activePatternResult_1[1];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return [bonus, rest];
        default: {
            let matchResult_1, penalty, rest_1;
            const activePatternResult_2 = $007CStr$007C_$007C("-", _arg[0], _arg[1]);
            if (activePatternResult_2 != null) {
                const activePatternResult_3 = $007CIntNoWhitespace$007C_$007C(activePatternResult_2);
                if (activePatternResult_3 != null) {
                    matchResult_1 = 0;
                    penalty = activePatternResult_3[0];
                    rest_1 = activePatternResult_3[1];
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return [op_UnaryNegation_Int32(penalty), rest_1];
                default:
                    return void 0;
            }
        }
    }
}

export const Parser_$007CRoll$007C_$007C = pack((_arg) => {
    let matchResult, bonusOrPenalty, dSize, n, rest;
    const activePatternResult = $007CInt$007C_$007C(_arg);
    if (activePatternResult != null) {
        let activePatternResult_1;
        const tupledArg = activePatternResult[1];
        activePatternResult_1 = Parser_$007CDieSize$007C_$007C(tupledArg[0], tupledArg[1]);
        if (activePatternResult_1 != null) {
            let activePatternResult_2;
            const tupledArg_1 = activePatternResult_1[1];
            activePatternResult_2 = Parser_$007CIntModifier$007C_$007C(tupledArg_1[0], tupledArg_1[1]);
            if (activePatternResult_2 != null) {
                matchResult = 0;
                bonusOrPenalty = activePatternResult_2[0];
                dSize = activePatternResult_1[0];
                n = activePatternResult[0];
                rest = activePatternResult_2[1];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return [RollSpec_create_4F7761DC(n, dSize, bonusOrPenalty), rest];
        default: {
            let matchResult_1, dSize_1, n_1, rest_1;
            const activePatternResult_3 = $007CInt$007C_$007C(_arg);
            if (activePatternResult_3 != null) {
                let activePatternResult_4;
                const tupledArg_2 = activePatternResult_3[1];
                activePatternResult_4 = Parser_$007CDieSize$007C_$007C(tupledArg_2[0], tupledArg_2[1]);
                if (activePatternResult_4 != null) {
                    matchResult_1 = 0;
                    dSize_1 = activePatternResult_4[0];
                    n_1 = activePatternResult_3[0];
                    rest_1 = activePatternResult_4[1];
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return [RollSpec_create_Z37302880(n_1, dSize_1), rest_1];
                default: {
                    const activePatternResult_5 = $007CInt$007C_$007C(_arg);
                    if (activePatternResult_5 != null) {
                        const rest_2 = activePatternResult_5[1];
                        const v = activePatternResult_5[0] | 0;
                        return [RollSpec_create_Z524259A4(v), rest_2];
                    }
                    else {
                        return void 0;
                    }
                }
            }
        }
    }
});

//# sourceMappingURL=Random.fs.js.map
